import { render } from "./teaTrainTask.vue?vue&type=template&id=17bee426&scoped=true"
import script from "./teaTrainTask.vue?vue&type=script&lang=js"
export * from "./teaTrainTask.vue?vue&type=script&lang=js"

import "./teaTrainTask.vue?vue&type=style&index=0&id=17bee426&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bee426"]])

export default __exports__